const firstRunInput = {
  heading: 'New analysis',
  history: 'Analysis history',
  basicInfo: 'Basic information',
  itemName: 'Part name',
  itemNamePlaceholder: 'e.g. brake pad, ECU board',
  nulNotAllowed: 'Remove the NUL character (U+0000) from this field',
  itemNameRequired: 'Enter the part name',
  title: 'Analysis title',
  titlePlaceholder: 'e.g. 2024 model specification change',
  cadPlaceholder: 'Select a CAD model',
  modeLabels: { old_new: 'Old/new specifications', difference: 'Difference specification' },
  cadHelp: 'Optional. The CAD model this analysis refers to.',
  specifications: 'Specifications',
  modeLabel: 'What to enter',
  modes: {
    old_new: 'Old/new specifications',
    difference: 'Difference specification',
  },
  sourceKinds: { text: 'Direct text', document: 'Registered document', derived: 'Edited copy' },
  editCopy: 'Edit extracted text',
  derivedHelp: 'Copy of {{name}} (version {{version}}). The original is unchanged. Edits create unverified candidates.',
  textHelp: 'Direct text creates unverified candidates. Switching sources keeps your drafts.',
  hiddenDraftKept: 'What you entered in the other option is kept but is not sent.',
  mixedInputUnsupported: 'Use two registered documents or two pasted specifications. Combining a document with pasted text is not supported yet. Your input is preserved.',
  fields: {
    old: 'Old specification',
    new: 'New specification',
    difference: 'Difference between the old and new specifications',
  },
  placeholders: {
    old: 'Enter the old specification',
    new: 'Enter the new specification',
    difference: 'Enter the difference between the old and new specifications',
  },
  required: {
    old: 'Enter the old specification or select a registered document',
    new: 'Enter the new specification or select a registered document',
    difference: 'Enter the difference or select a registered document',
  },
  supplement: 'Supplemental context',
  supplementPlaceholder: 'Conditions, constraints or background that are not in the documents',
  supplementHelp: 'Optional. Passed to the analysis together with the specifications.',
  analysisInfo:
    'AI compares the specifications, extracts the changes and analyses failure modes. This can take a few minutes.',
  start: 'Start analysis',
  starting: 'Starting…',
};

export default firstRunInput;
